import { cx } from '@emotion/css';
import { FC } from 'react';

interface BackdropProps extends React.HTMLAttributes<HTMLDivElement> {
  visible: boolean;
}

export const Backdrop: FC<React.PropsWithChildren<BackdropProps>> = ({ children, visible, className }) => {
  return (
    <div className={cx(className)}>
      {visible && <div className="absolute z-30 h-full w-full animate-fade-in bg-primary-black/30" />}
      {children}
    </div>
  );
};
